import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import {
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderTableActivationDirective,
  ElderTableComponent,
  ElderTableToolbarDirective,
  UuidUtil,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject, Observable } from 'rxjs'
import { ScrapSpec } from '../scrap-spec'
import { ScrapSpecDetailComponent } from '../scrap-spec-detail/scrap-spec-detail.component'

@Component({
  selector: 'app-scrap-spec-browser',
  templateUrl: './scrap-spec-browser.component.html',
  styleUrls: ['./scrap-spec-browser.component.scss'],
  imports: [
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
    ElderTableComponent,
    ElderTableActivationDirective,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    ScrapSpecDetailComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class ScrapSpecBrowserComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly scrapSpecs$ = new BehaviorSubject<ScrapSpec[]>([])

  @Output()
  public readonly scrapSpecsChange: EventEmitter<ScrapSpec[]> = new EventEmitter<ScrapSpec[]>()

  private readonly _selectedSpec$ = new BehaviorSubject<ScrapSpec>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set scrapSpecs(specs: ScrapSpec[]) {
    if (specs) {
      specs.forEach((s) => (s.id = UuidUtil.weakUuid4()))
    }
    this.scrapSpecs$.next(specs)
  }

  public get scrapSpecs(): ScrapSpec[] {
    return this.scrapSpecs$.getValue()
  }

  public set selectedSpec(spec: ScrapSpec) {
    this._selectedSpec$.next(spec)
  }

  public get selectedSpec$(): Observable<ScrapSpec> {
    return this._selectedSpec$.asObservable()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public addSpec(): void {
    const newSpec = new ScrapSpec()
    this.scrapSpecs = [...this.scrapSpecs, newSpec]
    this.selectedSpec = newSpec
    this.scrapSpecsChange.emit(this.scrapSpecs)
  }

  public onRemoveSpec(toRemove: ScrapSpec[]) {
    this.selectedSpec = null

    toRemove.forEach((r) => this.scrapSpecs.splice(this.scrapSpecs.indexOf(r), 1))
    this.scrapSpecs = [...this.scrapSpecs]
    this.scrapSpecsChange.emit(this.scrapSpecs)
  }
}
